<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Account No. Suffix
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryAcctSufFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryAcctSufFilterForm"
                            v-model="filtersAcctSuf.accountNoSuffix"
                            :label="filtersAcctSufLabel.accountNoSuffix"
                            :error-messages="errors.collect('filterAcctSuf')"
                            data-vv-name="filterAcctSuf"
                            :data-vv-as="filtersAcctSufLabel.accountNoSuffix"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearAcctSufFilters(true)">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doAcctSufFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="acctSufHeaders"
          :items="acctSufItems"
          v-bind:options.sync="paginationAcctSuf"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsAcctSuf"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.acctNoSfx }}</td>
              <td>{{ row.item.description }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignAcctSuf(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationAcctSuf: {
        page: 1
      }
    }
  },
  mounted() {
  },
  watch: {
    boolRefresh: function(value) {
      if (value) {
        this.doClearAcctSufFilters()
      }
    },
    'paginationAcctSuf': function(value) {
      this.doClearAcctSufFilters()
    }
  },
  methods: {
    closeDialog() {
      this.filtersAcctSuf.accountNoSuffix = ''
      this.$emit('close')
    },
    doClearAcctSufFilters(toClear) {
      if (toClear === true) {
        this.filtersAcctSuf.accountNoSuffix = ''
      }
      this.filtersAcctSuf.acctNoSfxApplnInt = this.acctNoSfxApplnInt
      this.fetchAcctSufData()
    },
    doAcctSufFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryAcctSufFilterForm').then(result => {
        if (result) {
          this.paginationAcctSuf.page = 1
          this.filtersAcctSuf.acctNoSfxApplnInt = this.acctNoSfxApplnInt
          this.fetchAcctSufData()
        }
      })
    },
    assignAcctSuf(data) {
      // Use $emit to call parent Accounts page method assignAcctSuf and pass the value
      this.$emit('assign-acct-suf-info', data)
      this.$emit('assign-acct-suf', data.acctNoSfx)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin],
  props: {
    acctNoSfxApplnInt: {
      type: String,
      default: ''
    },
    boolRefresh: {
      type: Boolean,
      default: true
    }
  }
}
</script>
